<div class="img_editor">
    <div class="webgl-wrapper">
        <div class="editor_head">
            <div class="side left">
                <button mat-icon-button (click)="resetCrop()" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Return original' | translate }}">
                    <mat-icon>restore</mat-icon>
                </button>
            </div>

            <div class="middle">
                <ng-container [ngSwitch]="mode">
                    <ng-container *ngSwitchCase="'Crop'">
                        <button type="button" mat-icon-button [matMenuTriggerFor]="resolMenu" aria-label="Example icon-button with a menu" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Crop frame proportion' | translate }}">
                            {{currentAspectRatio.w === 0 && currentAspectRatio.h === 0 ? ('Free' | translate) : currentAspectRatio.w + ':' + currentAspectRatio.h}}
                        </button>
                        <mat-menu #resolMenu="matMenu" class="ratio_value_menu_class" overlayPanelClass='ratio_value_menu'>
                            <button mat-menu-item (click)="setAspectRatio(1, 1)" [class.active]="currentAspectRatio.w === 1 && currentAspectRatio.h === 1">1:1</button>
                            <button mat-menu-item (click)="setAspectRatio(3, 4)" [class.active]="currentAspectRatio.w === 3 && currentAspectRatio.h === 4">3:4</button>
                            <button mat-menu-item (click)="setAspectRatio(4, 3)" [class.active]="currentAspectRatio.w === 4 && currentAspectRatio.h === 3">4:3</button>
                            <button mat-menu-item (click)="setAspectRatio(9, 16)" [class.active]="currentAspectRatio.w === 9 && currentAspectRatio.h === 16">9:16</button>
                            <button mat-menu-item (click)="setAspectRatio(16, 9)" [class.active]="currentAspectRatio.w === 16 && currentAspectRatio.h === 9">16:9</button>
                            <button mat-menu-item (click)="setAspectRatio(0, 0)" [class.active]="currentAspectRatio.w === 0 && currentAspectRatio.h === 0">Free</button>
                        </mat-menu>
                        <button mat-icon-button class="ml-1" (click)="cropWithWebGLBest()" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Apply crop' | translate }}">
                            <mat-icon>crop</mat-icon>
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Finetune'">
                        <button mat-raised-button class="ml-1" *ngIf="!checkIfZeroFinetune()" (click)="applyFinetuneToTexture()" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Apply Finetune' | translate }}">
                            {{"Apply"}}
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Filter'">
                        <button mat-raised-button class="ml-1" *ngIf="!checkIfZeroFinetune()" (click)="applyFinetuneToTexture()" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Apply Filter' | translate }}">
                            {{"Apply"}}
                        </button>
                    </ng-container>
                    
                </ng-container>
                

            </div>
                
            <div class="side right">
                <ng-container *ngIf="mode == 'Crop' || checkIfZeroFinetune()">
                    <button mat-icon-button (click)="downloadToDevice()" *ngIf="exportCanvas" style="color: #fff;" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Download to device' | translate }}">
                        <mat-icon>save_alt</mat-icon>
                    </button>
                    <button class="ml-1" mat-icon-button (click)="downloadToDevice(true)" *ngIf="exportCanvas" style="color: #409621;" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Upload result to the Reports.re' | translate }}">
                        <mat-icon>save</mat-icon>
                    </button>        
                </ng-container>
            </div>
        </div>
        <div class="editor_main">

            <div class="editor_funcs">
                <div class="func" *ngFor="let item of mods" (click)="mode = item.name" [ngClass]="{'active': mode == item.name}">
                    <mat-icon>{{item.icon}}</mat-icon>
                    <span>{{item.name | translate}}</span>
                </div>
            </div>

            <div class="editor_body">
                <canvas #glCanvas width="1120" height="672"></canvas>
                <div class="crop-overlay" *ngIf="imageWidth && imageHeight && mode == 'Crop'"
                    (pointerdown)="startCropDrag($event)"
                    (pointermove)="onCropDrag($event)"
                    (pointerup)="endCropDrag()"
                    (pointerleave)="endCropDrag()">
                    <div class="crop-area"
                        [style.width.px]="cropRect.width"
                        [style.height.px]="cropRect.height"
                        [style.left.px]="offsetX + cropRect.x"
                        [style.top.px]="offsetY + cropRect.y">
                        
                    <div class="crop-handle top-left" (pointerdown)="startResize($event, 'top-left')"></div>
                    <div class="crop-handle top-right" (pointerdown)="startResize($event, 'top-right')"></div>
                    <div class="crop-handle bottom-left" (pointerdown)="startResize($event, 'bottom-left')"></div>
                    <div class="crop-handle bottom-right" (pointerdown)="startResize($event, 'bottom-right')"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="editor_footer" [ngSwitch]="mode">
            <ng-container *ngSwitchCase="'Crop'">
                <span class="angle">{{currentAngle}}°</span>
                <app-slider-value [value]="currentAngle" (angleChanged)="onAngleChanged($event)"></app-slider-value>
            </ng-container>
            <ng-container *ngSwitchCase="'Finetune'">
                <ng-container *ngFor="let param of finetuneParams">
                    <ng-container *ngIf="finetune == param.name">
                        <span class="angle">{{param.value}}</span>
                        <app-slider-cst-value [min]="-100" [max]="100" [value]="param.value" (angleChanged)="updateFinetune($event, param.key)"></app-slider-cst-value>
                    </ng-container>
                </ng-container>
   
                <div class="footer_tabs">
                    <div *ngFor="let param of finetuneParams" (click)="finetune = param.name" [ngClass]="{'active': finetune == param.name}">{{param.name | translate}}</div>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Filter'">   
                <div class="footer_tabs fil_tabs">
                    <div class="fil" *ngFor="let filter of filters" (click)="applyFilter(filter)" [ngClass]="{'active': isActiveFilter(filter)}">{{filter.name | translate}}</div>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- <div class="finetune-controls">
        <div class="control" *ngFor="let param of finetuneParams">
            <label>{{param.name | translate}}</label>
            <mat-slider
                class="example-margin"
                [min]="-100" 
                [max]="100" 
                [step]="1"
                [value]="param.value"
                (input)="updateFinetune($event, param.key)">
            </mat-slider>
        </div>
    </div> -->

</div>



<div class="dev_tool" *ngIf="data?.user?.external_id == 8166">
    <pre>
        {{cropRect | json}}
    </pre>
    <p>offsetX:{{offsetX}}</p>
    <p>offsetY:{{offsetY}}</p>
</div>